import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    internalComments: string;
    publicComments: string;
    allComments: string;
    private: string;
    public: string;
    all: string;
    moveTo: string;
    copyTo: string;
    copyComments: string;
    includeComments: string;
    label: string;
    copyButton: (count: number) => string | React.ReactNode;
    moveButton: (count: number) => string | React.ReactNode;
    maxAssetCountTooltipText: (maxAssetCount: number) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            internalComments: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MoveToCopyToSheet.internalComments?c=3ger3ktvstpy2", defaultMessage: "Internal comments" }));
                },
                enumerable: true,
                configurable: true
            },
            publicComments: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MoveToCopyToSheet.publicComments?c=301i1thjw5isc", defaultMessage: "Public comments" }));
                },
                enumerable: true,
                configurable: true
            },
            allComments: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MoveToCopyToSheet.allComments?c=1inbo8lnpn0ir", defaultMessage: "All comments" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Shorter label for private comments */
            private: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MoveToCopyToSheet.private?c=3f8tzepp9n2dx", defaultMessage: "Internal" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Shorter label for public comments */
            public: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MoveToCopyToSheet.public?c=2zxlfw8sv8igh", defaultMessage: "Public" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Shorter label for all comments */
            all: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MoveToCopyToSheet.all?c=3pgdetk0ulcug", defaultMessage: "All" }));
                },
                enumerable: true,
                configurable: true
            },
            moveTo: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MoveToCopyToSheet.moveTo?c=1f0zsmjr74ohs", defaultMessage: "Move to" }));
                },
                enumerable: true,
                configurable: true
            },
            copyTo: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MoveToCopyToSheet.copyTo?c=bvkl0yf89riu", defaultMessage: "Copy to" }));
                },
                enumerable: true,
                configurable: true
            },
            copyComments: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MoveToCopyToSheet.copyComments?c=17q8dfq2ld7j3", defaultMessage: "Also copy comments" }));
                },
                enumerable: true,
                configurable: true
            },
            includeComments: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MoveToCopyToSheet.includeComments?c=gr90p2nhoj0n", defaultMessage: "Include comments" }));
                },
                enumerable: true,
                configurable: true
            },
            label: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "MoveToCopyToSheet.label?c=cwgb0x8kqvpy", defaultMessage: "move to copy to sheet" }));
                },
                enumerable: true,
                configurable: true
            },
            copyButton: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "MoveToCopyToSheet.copyButton?c=2eonuwq5yeh9m", defaultMessage: "{count, plural, one {Copy 1 Item} other {Copy {count} Items}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            moveButton: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "MoveToCopyToSheet.moveButton?c=3qauziveylblv", defaultMessage: "{count, plural, one {Move 1 Item} other {Move {count} Items}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            maxAssetCountTooltipText: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (maxAssetCount: number) => __intl__.intl().formatMessage({ id: "MoveToCopyToSheet.maxAssetCountTooltipText?c=qj9v8ftsu2c0", defaultMessage: "Please select {maxAssetCount} assets or fewer to perform this action." }, { maxAssetCount: maxAssetCount }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
